import { ReactNode, useCallback } from "react";
import { cva } from "class-variance-authority";
import { useInputGroupContext } from "./InputGroup";

export interface InputRightAddonProps {
  className?: string;
  children: ReactNode;
}

const styles = cva("absolute right-0 inline z-10 flex items-center");
/**
 *
 */
export const InputRightAddon = ({
  className,
  children,
}: InputRightAddonProps) => {
  const context = useInputGroupContext();
  const fn = useCallback(
    (ref: any) => ref && context?.setRightWidth(ref.clientWidth),
    [],
  );
  return (
    <div ref={fn} className={styles({ className })}>
      {children}
    </div>
  );
};
